module.exports = __webpack_public_path__ + "img/45.10.pH.77746772.png";